module.exports = __webpack_public_path__ + "img/calendario-sm.89a90c5d.png";